module.exports = __webpack_public_path__ + "static/layers-f445fd1fb7d6f8fe56fbcce5572d634f.png";